import ZJApi from './api'
import utils from '../../utils'

const info = {
    service: 'FileService',
    controller: 'File'
}
const methods = [
    'GetFileList',
    'ListFile',
    'DeleteFile'
]

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
}

const FileApi = ZJApi.defineNewApi('FileApi', factory)

export default FileApi